export default function () {
  const accordions = document.querySelectorAll('.accordion .accordion__btn');
  const userMenuMobile = document.getElementById('user-menu--mobile');
  accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      // Close other accordion open when open accordion in menu user
      if (userMenuMobile && userMenuMobile.contains(accordion)) {
        const userMenuMobileAccordion = document.querySelectorAll('#user-menu--mobile .accordion__btn');
        userMenuMobileAccordion.forEach((menuAccordion) => {
          if (accordion !== menuAccordion) {
            menuAccordion.classList.remove('accordion__btn--active');
            const panelSibling = menuAccordion.nextElementSibling;
            if (panelSibling) {
              panelSibling.style.display = 'none';
            }
          }
        });
      }

      accordion.classList.toggle('accordion__btn--active');

      const panel = accordion.nextElementSibling;
      if (panel.style.display === 'block') {
        panel.style.display = 'none';
      } else {
        panel.style.display = 'block';
      }
    });
  });
}
